import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";
import { useLookups } from "@/hooks/useLookups";

const NONE = "__none";

// Dropdown fed by a governed supporting list; keeps a historical (now inactive) value visible.
export function LookupSelect({ type, value, onChange, testid, disabled, allowEmpty = true, placeholder = "Select", exclude = [] }) {
  const { opts } = useLookups();
  const list = opts(type).filter((x) => !exclude.includes(x));
  const all = value && !list.includes(value) ? [value, ...list] : list;
  return (
    <Select value={value || ""} onValueChange={(v) => onChange(v === NONE ? "" : v)} disabled={disabled}>
      <SelectTrigger className="bg-white" data-testid={testid}><SelectValue placeholder={list.length ? placeholder : "No values yet — add in Supporting lists"} /></SelectTrigger>
      <SelectContent>
        {allowEmpty && <SelectItem value={NONE} className="text-slate-400">— none —</SelectItem>}
        {all.map((o) => <SelectItem key={o} value={o}>{o}{!list.includes(o) ? " (inactive)" : ""}</SelectItem>)}
      </SelectContent>
    </Select>
  );
}
